import React from "react";
import { Wrapper } from "./inAssessment.styles";
import clipBoard from "../animatedGifs/tracker-assessment-optimised.gif";

export const InAssessment = () => {
  return (
    <Wrapper>
      <img
        className="animated-gif-clipboard"
        src={clipBoard}
        alt="good news!"
      />
      <h3>Good news!</h3>
      <p>
        Your application is currently being assessed by one of our consultants.
      </p>
      <div className="attention-box">
        <h3>ATTENTION</h3>
        <p>
          Our consultants may need some further information from you to help
          finalise your assessment, so please keep an eye out in case they send
          you an email or SMS.
        </p>
      </div>
    </Wrapper>
  );
};
